<template>
  <div :class="className" class="title-widget">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: "center",
      validator: (val) => ["left", "center", "right"].includes(val),
    },
    small: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    link: {
      type: String,
    },
  },
  computed: {
    className() {
      const alignClass = {
        left: "text-left align-start",
        center: "text-center align-center",
        right: "text-right align-end",
      };

      const className = [
        "d-flex flex-column justify-center font-weight-medium title-widget",
        alignClass[this.align],
        !this.dark ? "title-widget--light" : "title-widget--dark",
        !this.small ? "text-h5 text-md-h4" : "text-h6 text-md-h5",
      ];

      return className;
    },
  },
};
</script>

<style lang="scss" scoped>
.title-widget--light {
  --text: var(--v-primary-base);
}
.title-widget--dark {
  --text: #ffffff;
}

.title-widget {
  color: var(--text) !important;
}
</style>
